module.exports = __webpack_public_path__ + "media/images/main-bg-27905fd416210513195be1a56ca5fff6.png";